import { SmartInput } from 'app/components/shared/FormComponents/SmartInput'
import { FormGroup } from 'app/components/shared/FormGroup'
import { Card } from 'app/components/ui/Card'
import { Text } from 'app/components/ui/Text'
import { Title } from 'app/components/ui/Title'
import { routes } from 'app/routing/routes'
import React from 'react'
import { Link } from 'react-router-dom'

type Props = {
  isSuccess: boolean
  isInvitation?: boolean
}
export const SignupInnerForm = ({
  isSuccess,
  isInvitation,
}: Props): JSX.Element => {
  return (
    <Card bgColor='white' padding={isSuccess ? '4rem 2rem' : '2rem'} shadow>
      {isSuccess && !isInvitation ? (
        <>
          <Title size={4} mb={1}>
            Manca pochissimo!
          </Title>
          <Text>
            Controlla la tua casella di posta per procedere allo step finale di
            registrazione.
          </Text>
        </>
      ) : isSuccess && isInvitation ? (
        <>
          <Title size={4} mb={1}>
            Grazie per aver confermato l&apos;invito!
          </Title>
          <Text>
            <Link to={routes.login.path}>Clicca qui</Link> per effettuare
            l&apos;accesso e continuare ad utilizzare le funzionalità del
            servizio.
          </Text>
        </>
      ) : (
        <>
          <FormGroup>
            <SmartInput
              label='Email'
              type='email'
              name='email'
              placeholder='Inserisci la tua mail personale'
              labelRequired
              disabled={isInvitation}
            />
          </FormGroup>
          <FormGroup>
            <SmartInput
              label='Password'
              type='password'
              name='password'
              placeholder='Inserisci la password'
              labelRequired
            />
          </FormGroup>
          <FormGroup>
            <SmartInput
              label='Conferma Password'
              type='password'
              name='passwordConfirmation'
              placeholder='Conferma la password'
              labelRequired
            />
          </FormGroup>

          {!isInvitation && (
            <Text>
              Hai già un account?{' '}
              <Link to={routes.login.path}>Effettua l&apos;accesso</Link>
            </Text>
          )}
        </>
      )}
    </Card>
  )
}
